<template>
  <div class="flex-container">
    <div class="menubar flex-100">
      <span class="title">
        Voor wie wilt u een beleggingsrekening aanvragen?
      </span>
      <span class="setting hide-mobile">Type rekening</span>
    </div>
    <div v-if="sdk.isBecome" class="msg flex-100">
      <b>Let op!</b>
      Als adviseur bent u ingelogd als {{$parent.email}}, u kunt de vragen
      beantwoorden alsof u deze persoon bent.
    </div>

    <div
      @click="newInvestmentAccount('Mijzelf')"
      class="card option most-used-selected flex-33"
    >
      <div class="most-used-content">
        <b>Meest gekozen</b>
      </div>
      <h2><awesomeIcon icon="user"/> Mijzelf</h2>
      <p>U vraagt een beleggingsrekening aan die alleen op uw naam staat.</p>
    </div>
    <div
      @click="newInvestmentAccount('Samen')"
      class="card option most-used-unselected flex-33"
    >
      <h2><awesomeIcon icon="users"/> Samen (en/of)</h2>
      <p>
        U vraagt een beleggingsrekening aan waar uzelf en/of uw partner, kind(eren) of vriend(en)
        geld kunnen inleggen. U bent gezamenlijk eigenaar van het belegde vermogen.
      </p>
    </div>
    <div
      @click="newInvestmentAccount('Bedrijf')"
      class="card option most-used-unselected flex-33"
    >
      <h2><awesomeIcon icon="building"/> Mijn bedrijf</h2>
      <p>
        U vraagt een beleggingsrekening aan voor uw eigen bedrijf of voor een bedrijf dat u
        vertegenwoordigt.
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'IntakeRekeningSelectPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  computed: {
    value() {
      return this.modelValue;
    },
  },
  methods: {
    newInvestmentAccount(type) {
      if (type === 'Mijzelf') {
        // Mijzelf
        this.modelValue.rekeningData.type = 'Particuliere rekening';
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Rekeninghouder';
        this.modelValue.rekeningData.step = 0;
      } else if (type === 'Samen') {
        // Samen
        this.modelValue.rekeningData.type = 'Particuliere rekening';
        this.modelValue.rekeningData.step = 0;
        this.modelValue.persoonsData.splice(1);
        this.modelValue.persoonsData[0].type = 'Rekeninghouder';
        this.modelValue.persoonsData.push({ type: 'Rekeninghouder' });
      } else {
        // Bedrijf
        this.modelValue.rekeningData.type = 'Bedrijfsrekening';
        this.modelValue.step = 3;
        this.modelValue.persoonsData.splice(1);
        delete this.modelValue.persoonsData[0].type;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media #{$desktop} {
  .card.option { min-height: 200px; }
}
.setting {
  float: right;
}
.flex-container {
  column-gap: 20px;
  row-gap: 20px;
  @media #{$mobile} {
    row-gap: 10px;
    padding: 43px 10px 10px;
  }
}
</style>
